import React from 'react'

import { createSortContext } from 'modules/core/components/DataTable/contexts/SortContext'

export default function useSort<S extends string>() {
  const value = React.useContext(createSortContext<S>())

  if (!value) {
    throw new Error('useSort must be used within a SortProvider')
  }

  return value
}
